import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideClientHydration } from '@angular/platform-browser';
import { appRoutes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';
import { refreshInterceptor } from './interceptors/refresh.interceptor';
import { MonitoringErrorHandler } from './monitoring';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // anchorScrolling: cross-page fragment links (e.g. /#pricing from the
    // blog header) must scroll after the landing page loads, not no-op.
    provideRouter(
      appRoutes,
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })
    ),
    // refreshInterceptor is INNER of errorInterceptor so it sees a 401 first
    // and can silently rotate + retry before the error interceptor logs out.
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, errorInterceptor, refreshInterceptor])),
    // Reuses the prerendered DOM on public pages instead of destroying and
    // re-rendering it. Dev serve is CSR-only (prerender lives in the
    // production build config), so dev logs a benign NG0505 "hydration was
    // requested but no SSR content" warning — expected, ignore it.
    provideClientHydration(),
    // Same console behavior as the default handler, plus a BugSink report
    // when error tracking is configured (see monitoring.ts).
    { provide: ErrorHandler, useClass: MonitoringErrorHandler },
  ],
};
